import React, { useState } from 'react';
import { toast } from 'sonner';
import { Card, Pill } from '../ui';
import { adminApi, PROGRAM_NAMES } from '../../../pages/journey/journeyApi';

const ProgramPlacement = ({ studentId, pw, onSaved }) => {
  const practice = pw.items.filter((i) => i.mission.kind === 'practice');
  const [picked, setPicked] = useState(() => new Set(practice.filter((i) => i.state === 'placed_out').map((i) => i.mission.id)));
  const [busy, setBusy] = useState(false);
  if (!practice.length) return null;
  const toggle = (id) => setPicked((p) => { const n = new Set(p); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const useSuggested = () => setPicked(new Set([...picked, ...pw.suggested_skips]));
  const save = async () => {
    setBusy(true);
    try { await adminApi(`/students/${studentId}/placement`, { method: 'PUT', body: { program_id: pw.program_id, mission_ids: [...picked] } }); toast.success('Skips confirmed'); onSaved(); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <div className="mt-4" data-testid={`placement-${pw.program_id}`}>
      <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
        <p className="text-xs uppercase tracking-widest text-teal-700">{PROGRAM_NAMES[pw.program_id]} · starter check level: {pw.level || 'pending'}</p>
        {pw.suggested_skips.length > 0 && <button onClick={useSuggested} className="text-xs font-semibold text-teal-700" data-testid={`placement-use-suggested-${pw.program_id}`}>Tick suggested ({pw.suggested_skips.length})</button>}
      </div>
      {practice.map((i) => (
        <label key={i.mission.id} className="flex items-center gap-3 text-sm py-1.5 cursor-pointer">
          <input type="checkbox" checked={picked.has(i.mission.id)} onChange={() => toggle(i.mission.id)} disabled={['completed', 'validated', 'awaiting_review'].includes(i.state)}
            data-testid={`placement-check-${i.mission.id}`} className="accent-teal-600 w-4 h-4" />
          <span className="flex-1">{i.mission.title} <span className="text-xs text-slate-500 capitalize">· {i.mission.level}</span></span>
          {i.suggested_skip && i.state !== 'placed_out' && <Pill className="bg-amber-50 text-amber-700">Suggested by starter check</Pill>}
        </label>))}
      <button onClick={save} disabled={busy} data-testid={`placement-save-${pw.program_id}`}
        className="mt-2 bg-[#0b1f4d] text-white text-sm font-semibold px-4 py-2 rounded-full disabled:opacity-60">{busy ? 'Saving…' : 'Confirm skips'}</button>
    </div>
  );
};

export const PlacementPanel = ({ d, onSaved }) => {
  if (!d.pathways.some((pw) => pw.items.some((i) => i.mission.kind === 'practice'))) return null;
  return (
    <Card data-testid="admin-placement-panel">
      <p className="font-outfit font-semibold text-[#0b1f4d]">Confirm skipped missions</p>
      <p className="text-sm text-slate-500 mt-1">The starter check only suggests skips. Students keep every mission open until you confirm. Skipped missions don't count toward progress.</p>
      {d.pathways.map((pw) => <ProgramPlacement key={`${pw.program_id}-${pw.suggested_skips.join()}-${pw.skipped}`} studentId={d.student.id} pw={pw} onSaved={onSaved} />)}
    </Card>
  );
};
